// PVS Training Matrix — per-process responsibility register.
//
// Powers the "View Responsible Personnel" popup on the Vessel Refurbishment
// Process Map. The list per process step is the names of people who are
// trained / authorised for that step, alongside their job title.
//
// Source of truth: the PVS Training Matrix knowledge-base document
// (maintained outside the application). Names listed here mirror that
// document; do not surface this file to end users.
//
// Shape:
//   TRAINING_MATRIX[processId] = [
//     { name: 'Display Name', jobTitle: 'Job Title' },
//     ...
//   ]
//
// `processId` MUST match a node `id` declared in
// `src/components/documents/VesselRefurbishmentProcessMap.js`.
//
// A missing key, or an empty array, will show an "awaiting matrix entry"
// notice in the popup.

export const TRAINING_MATRIX = {
  // Phase 1 — Receiving, identification & pre-inspection
  'vessel-unloading': [
    // { name: 'Example Name', jobTitle: 'HGV Driver' },
  ],
  'vessel-holding-area': [],
  'vessel-inventory': [],
  'vessel-identification': [],
  tagging: [],
  'nothing-required': [],
  'pre-inspection': [],
  'vessel-scrapped': [],
  'vessel-failure-report-submitted': [],
  'vessel-vapour-removal': [],

  // Phase 2 — Stripping, surface preparation & coating
  'vessel-valve-removal': [],
  'vessel-stud-fix-replacement': [],
  'vessel-surface-powder-coated': [],
  'vessel-coating-wet-sprayed': [],
  'pyrolysis-oven': [],
  'shot-blasting': [],
  'spray-booth': [],

  // Phase 3 — Final inspection & dispatch
  'vessel-inspection': [],
  'final-qc-checklist': [],
  'ready-for-dispatch': [],
};

// Returns the array of responsible / trained personnel for the given
// process step. Each entry is `{ name, jobTitle }`. Returns an empty
// array if the process is not present in the matrix.
export function getResponsiblePersonnel(processId) {
  const list = TRAINING_MATRIX[processId];
  return Array.isArray(list) ? list : [];
}
